import React, { FC } from 'react'

import { IconBroadbandRouterProps } from './IconBroadbandRouter.types'
import * as Styled from './styles/IconBroadbandRouter.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBroadbandRouter: FC<IconBroadbandRouterProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBroadbandRouterProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconBroadbandRouterProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='80' cy='112' r='6' />
        <path d='M66.18 69.86A4 4 0 0 1 63.35 63a24 24 0 0 1 33.85 0 4 4 0 0 1-5.63 5.69A16 16 0 0 0 69 68.7a4 4 0 0 1-2.82 1.16z' />
        <path d='M108.6 55.72a4 4 0 0 1-2.78-1.12l-.08-.08a36.05 36.05 0 0 0-50.88 0 4 4 0 0 1-5.66-5.66 44.05 44.05 0 0 1 62.16-.06l.07.06a4 4 0 0 1-2.83 6.83z' />
        <path d='M122.72 41.55a4 4 0 0 1-2.83-1.17 56.08 56.08 0 0 0-79.07-.07 4 4 0 0 1-5.65-5.67 64.11 64.11 0 0 1 90.37.08 4 4 0 0 1 0 5.66 3.94 3.94 0 0 1-2.82 1.17zM140 136H20a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h48a4 4 0 0 1 0 8H20a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h120a4 4 0 0 0 4-4v-24a4 4 0 0 0-4-4H92a4 4 0 0 1 0-8h48a12 12 0 0 1 12 12v24a12 12 0 0 1-12 12z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBroadbandRouter
